import { render } from "./Delegate.vue?vue&type=template&id=0a48a870"
import script from "./Delegate.vue?vue&type=script&lang=js"
export * from "./Delegate.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/Delegate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a48a870"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a48a870', __exports__)) {
    api.reload('0a48a870', __exports__)
  }
  
  module.hot.accept("./Delegate.vue?vue&type=template&id=0a48a870", () => {
    api.rerender('0a48a870', render)
  })

}


export default __exports__